export enum RealEstateStatusEnum {
	ACTIVE = 'ACTIVE',
	PENDING = 'PENDING',
	TEMPORARILY_OFF_MARKET = 'TEMPORARILY_OFF_MARKET',
	CANCELED = 'CANCELED',
	WITHDRAWN = 'WITHDRAWN',
	SOLD = 'SOLD',
	EXPIRED = 'EXPIRED',
	LEASED = 'LEASED'
}
